module.exports = __webpack_public_path__ + "img/logo_placeholder.945b10c9.png";